import styled from 'styled-components';

export const ElementContainer = styled.div`
  margin-bottom: 16px;
  & > div:first-child {
    margin-bottom: 12px;
  }
`;

export const EducationsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 700px;

  & > div {
    margin-right: 48px;
  }
`;

export const MainWrapper = styled.div`
  & > div:last-child {
    flex-wrap: wrap;
  }
`;
